import React, { useState, useEffect } from "react";
import $ from "jquery";
import "./App.scss";
import Routes from "./routes";
// import CookieFormModal from './../routes/website/cookie-form';
import { ToastContainer, toast } from "react-toastify";
import "../../node_modules/react-toastify/dist/ReactToastify.css";
import ReactTooltip from "react-tooltip";
import { getApiUrl } from "../utils/baseUrl";
import { CookiesProvider } from "react-cookie";
import { useCookies, Cookies } from "react-cookie";
import CacheBuster from "react-cache-buster";
import packageInfo from "../../package.json";

const cookie = new Cookies();
function App() {
  const [isCookieVisible, setIsCookieVisible] = useState(false);
  const [cookiesValue, setCookie] = useCookies(["ica"]);
  // Method which is used for cookie
  const getCookieStatus = () => {
    if (window.location.pathname !== "/privacy-policy") {
      const cookieValue = cookie.get("ica");
      if (cookieValue === undefined || cookieValue === null || cookieValue === false) {
        setIsCookieVisible(true);
      } else {
        setIsCookieVisible(false);
      }
    }
  };
  // End of the Above code
  // Below code is used to handle the Accepted Action on the Cookie Page
  const callingCookieAccepted = () => {
    setCookie("ica", true);
    setIsCookieVisible(false);
  };
  // End of the above code
  useEffect(() => {
    setTimeout(() => {
      // getCookieStatus();
    }, 5000);
  }, []);
  return (
    <div>
      <CacheBuster
        currentVersion={packageInfo.version}
        isEnabled={true} //If false, the library is disabled.
        isVerboseMode={false} //If true, the library writes verbose logs to console.
        loadingComponent={"Loading..."} //If not pass, nothing appears at the time of new version check.
        metaFileDirectory={"."} //If public assets are hosted somewhere other than root on your server.
      >
        <CookiesProvider>
          <ReactTooltip />
          <ToastContainer position="bottom-right" autoClose={5000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss pauseOnHover limit={1} />
          <Routes />
          {/* {!!isCookieVisible && isCookieVisible === true ? <CookieFormModal cookieAccepted={callingCookieAccepted}></CookieFormModal> : <span className="d-none"></span>} */}
        </CookiesProvider>
      </CacheBuster>
    </div>
  );
}

export default App;
